<div class="stepper-container">
  <ul class="nav nav-tabs" *ngIf="enableTitles">
    <li *ngFor="let step of stepperTitle; let i = index" [class.active]="i === currentStep">
      <a href="javascript:void(0)" (click)="setCurrentStep(i)">{{ step.title }}</a>
    </li>
  </ul>
  <div class="slider-content" style="overflow: hidden">
    <div class="slider-container transition-all duration-200 grid " [id]="'mySlider_' + idPrefix" [ngStyle]="{
        'position':'relative',
        'grid-template-columns':'repeat(' + this.stepperTitle.length + ', minmax(0, 1fr))',
        'width': this.stepperTitle.length * 100 +  '%',
    }">
      <ng-content></ng-content>
    </div>
  </div>
</div>
